import { gql } from '@apollo/client'
import React from 'react'

import { qrcodesClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useQrcodeState = () => React.useContext(Context)
export const useQrcode = () => useQrcodeState()?.qrcode
export const useQrcodePlaceId = () => useQrcode()?.data?.id
export const useQrcodeAssetId = () => useQrcode()?.data?.id

const QUERY = gql`
  query Qrcode($id: ID) {
    qrcode(id: $id) {
      id
      data
      activated
      type
      projectId
      recordId
    }
  }
`

const QrcodesLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: qrcodesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={!data?.qrcode?.id}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default QrcodesLoader
